import { useEffect, useState } from 'react';
import { Form, Card, Row, Col, Button, Image } from 'react-bootstrap';
import icUser from './assets/img/ic-user-circle.svg';


const UserAddAccess = ({
    formData,
    handleChange,
    handleAccessSubmit,
    isEditPage,
    isDisabled,
    isEditDisabled,
    isFieldsDisabled,
    actorRole
}) => {


    const [isEditing, setIsEditing] = useState(!isEditPage);
    const [tempFormData, setTempFormData] = useState({ ...formData }); // ✅ Store initial values


    // ✅ Enable editing mode
    const handleEditClick = () => {
        setIsEditing(true);
        setTempFormData({ ...formData }); // ✅ Store previous values
    };
    
    // ✅ Save changes and disable editing
    const handleSaveClick = async (e) => {
        e.preventDefault();
        if (typeof handleAccessSubmit === 'function') { // ✅ Ensure it's a function before calling
            await handleAccessSubmit(e);
            setIsEditing(false); // ✅ Exit edit mode after saving
        } else {
            console.error('Error: handleAccessSubmit is not a function.');
        }
    };
    
    // ✅ Cancel editing and restore previous values
    const handleCancelClick = () => {
        setIsEditing(false);
        Object.keys(tempFormData).forEach((key) => {
            handleChange({ target: { name: key, value: tempFormData[key] } });
        });
    };

    const ROLE_OPTIONS_BY_ACTOR = {
        superadmin: ['donatorUser','student','company','admin','titanAdmin','superadmin'],
        titanAdmin: ['donatorUser','student','company','admin','titanAdmin'],
    };

    const canonicalActorRoleKey = (() => {
        const raw = String(actorRole || '').trim();
        const key = raw.toLowerCase();
        if (key === 'superadmin' || key === 'super_admin') return 'superadmin';
        if (key === 'titanadmin' || key === 'titan_admin') return 'titanAdmin';
        return raw;
    })();

    const roleOptions = (ROLE_OPTIONS_BY_ACTOR[canonicalActorRoleKey] || []).filter(r => {
        if (canonicalActorRoleKey === 'titanAdmin') return r !== 'titanAdmin'; // hide same-level option
        return true;
    });

    const ROLE_LABELS = {
        donatorUser: 'Donator',
        student: 'Student',
        company: 'Company',
        admin: 'Admin',
        titanAdmin: 'Titan Admin',
        superadmin: 'Superadmin',
    };

    const editDisabled = typeof isEditDisabled === 'boolean' ? isEditDisabled : isDisabled;
    const fieldsDisabled = typeof isFieldsDisabled === 'boolean' ? isFieldsDisabled : isDisabled;

    // ✅ If the target user is superadmin, do not allow editing role in UI
    const isTargetSuperadmin = String(formData.role || '').trim() === 'superadmin';

    // ✅ If role loads later and turns out to be superadmin, exit edit mode to avoid "stuck" UI
    useEffect(() => {
        if (isTargetSuperadmin && isEditing) {
            setIsEditing(false);
        }
    }, [isTargetSuperadmin, isEditing]);

    return (
        <>
            <Card>
                <Card.Body>
                    <Row>
                        <Col md={12}>
                            {isEditPage && (
                                <div className="float-end">
                                    {!isEditing ? (
                                        <Button
                                            variant="outline-secondary"
                                            className="btn-sm"
                                            onClick={handleEditClick}
                                            disabled={editDisabled || isTargetSuperadmin}
                                        >
                                            Edit
                                        </Button>
                                    ) : (
                                        <>
                                            <Button
                                                variant="outline-secondary"
                                                className="btn-sm me-2"
                                                onClick={handleCancelClick}
                                                disabled={false}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                variant="primary"
                                                className="btn-sm"
                                                onClick={handleSaveClick}
                                                disabled={fieldsDisabled || isTargetSuperadmin}
                                            >
                                                Save
                                            </Button>
                                        </>
                                    )}
                                </div>
                            )}
                            <h3><span className="item-number">1.</span>Access & Permissions</h3>
                            <hr />
                        </Col>
                    </Row>
                    <>
                        {isEditing ? (
                            <>
                                <Row className="mb-3">
                                    <Col md={12}> 
                                        {/* User Role */}
                                        <Form.Group controlId="role">
                                            <Form.Label>Platform role</Form.Label>
                                            <Form.Select
                                                name="role"
                                                value={formData.role || ''}
                                                onChange={handleChange}
                                                disabled={!isEditing || fieldsDisabled || isTargetSuperadmin}
                                            >
                                                <option value="">Select role...</option>
                                                {roleOptions.map(r => (
                                                    <option key={r} value={r}>
                                                        {ROLE_LABELS[r] || r}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </>
                        ): (
                            // Not editing
                            <>
                                <Row className="mb-3">
                                    <Col md={12}>
                                        <div className="icon-text">
                                            <span className="icon" aria-hidden="true">
                                                <Image src={icUser} alt="Platform role" />
                                            </span>
                                            <span className="text">
                                                Platform role
                                                <br />
                                                <strong>
                                                    {ROLE_LABELS[formData.role] || formData.role || 'N/A'}
                                                </strong>
                                            </span>
                                        </div>
                                    </Col>
                                    
                                </Row>
                            </>
                        )}
                    </>
                    
                </Card.Body>
            </Card>
        </>
    );
};

export default UserAddAccess;
